export class CompanyStripeCustomer {
	public companyId: string;
	public stripeCustomerId: string;

	constructor(customer?: CompanyStripeCustomer) {
		Object.assign(this, customer);
	}
}
